<template>
  <div>
    <v-dialog :value="active" @click:outside="closedialog('cerrar')" scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Editar
                {{ type === "AgentList" ? "agente" : "usuario" }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre" v-slot="{ errors }">
                      <v-text-field
                        :disabled="type === 'AgentList'"
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="data.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="correo electrónico" rules="email" v-slot="{ errors }">
                      <v-text-field
                        :disabled="type === 'AgentList'"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Correo electrónico"
                        name="email"
                        prepend-inner-icon="mdi-email"
                        type="text"
                        color="blue-grey"
                        v-model="data.email"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="type === 'UserList'">
                    <ValidationProvider name="contraseña" v-slot="{ errors }">
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="data.password"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="data.password" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde indicarle la nueva
                        contraseña al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="Rol de acceso" v-slot="{ errors }">
                      <v-select
                        :items="options"
                        item-text="label"
                        item-value="value"
                        :disabled="type === 'AgentList'"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Rol de acceso"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="blue-grey"
                        v-model="data.role_id"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="data.role_id === 10">
                    <ValidationProvider name="Extensiones del usuario" v-slot="{ errors }">
                      <v-select
                        :items="userExtensionOptions"
                        :loading="isLoadingExtensionItems"
                        multiple
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensiones del usuario"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="blue-grey"
                        v-model="selectedUserExtensions"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                    <ValidationProvider name="Colas del usuario" v-slot="{ errors }">
                      <v-select
                        :items="queueItems"
                        :loading="isLoadingQueueItems"
                        item-text="name"
                        item-value="id"
                        multiple
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Colas del usuario"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="blue-grey"
                        v-model="selectedUserQueues"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <!-- Filtrar mensajes por cola -->
                  <v-col cols="12">
                    <v-checkbox class="mt-0 ml-2" v-model="data.enable_queues_chat" :false-value="0" :true-value="1">
                      <template v-slot:label>
                        Filtrar mensajes por cola
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" v-if="type === 'AgentList'">
                    <ValidationProvider name="colas" rules="required" v-slot="{ errors }">
                      <v-select
                        multiple
                        :disabled="isLoadingQueueItems"
                        :items="queueItems"
                        :item-text="(item) => `${item.name} (${item.number})`"
                        item-value="number"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Colas"
                        name="Colas"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="queueSelected"
                        :error-messages="errors"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @mousedown.prevent @click="toggle">
                            <v-list-item-action>
                              <v-icon :color="queueSelected.length > 0 ? 'indigo darken-4' : ''">
                                {{ icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Seleccionar todo
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="type === 'AgentList'">
                    <ValidationProvider name="Prioridad" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Prioridad"
                        name="priority_order"
                        prepend-inner-icon="mdi-alert"
                        type="text"
                        color="info"
                        v-model="userPriority"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="type === 'AgentList'">
                    <ValidationProvider name="extensión" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        :disabled="isLoadingExtensionItems"
                        :items="extesionItems"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensión"
                        name="Extensión"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="extesionSelected"
                        :error-messages="errors"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="type === 'AgentList'">
                    <ValidationProvider name="extensión opcional" v-slot="{ errors }">
                      <v-autocomplete
                        :disabled="isLoadingExtensionItems"
                        :items="extesionOptItems"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensión opcional"
                        name="Extensión opcional"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="extesionOptSelected"
                        :error-messages="errors"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="data.role_id === 3 || data.role_id === 8">
                    <v-checkbox
                      class="mt-0 ml-2"
                      v-model="data.auto_connection"
                      label="Conexión automática a planta"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closedialog('cerrar')">
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(sendform)"
                >Actualizar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import { DIALOG_MAX_HEIGHT } from "@/utils";
import { accessRoleOptions } from "../assets";
import { PbxHttpClient } from "@/services";

export default {
  props: ["type", "active", "data"],

  components: {
    vuescroll,
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      loading: false,
      isLoadingQueueItems: false,
      isLoadingExtensionItems: false,
      showPassword: false,
      dialog: false,
      options: accessRoleOptions,
      queueItems: [],
      queueSelected: [],
      extesionItems: [],
      extesionOptItems: [],
      userExtensionOptions: [],
      selectedUserExtensions: [],
      selectedUserQueues: [],
      extesionSelected: null,
      extesionOptSelected: null,
      userPriority: null,
    };
  },

  created() {
    this.getQueues();
    this.getExtension();

    if ([2].includes(this.Role)) {
      this.options.splice(0, 1);
    }
  },

  mounted() {
    for (let i in this.data.queues) {
      this.queueSelected.push(this.data.queues[i].number);
    }

    this.extesionSelected = this.data.extension;
    this.userPriority = this.data.priority_order;
    this.extesionOptSelected = this.data.extension_opcional;

    this.data.auto_connection === 1 ? (this.data.auto_connection = true) : (this.data.auto_connection = false);
    if (this.data.role_id === 10) {
      this.getUserQueuesAndExtensions();
    }
  },

  computed: {
    icon() {
      if (this.likesAllQueues) return "mdi-close-box";
      if (this.likesSomeQueues) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllQueues() {
      return this.queueSelected.length === this.queueItems.length;
    },

    likesSomeQueues() {
      return this.queueSelected.length > 0 && !this.likesAllQueues;
    },

    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    SelectedRole() {
      return this.data.role_id;
    },
  },

  watch: {
    extesionSelected(value) {
      this.extesionOptItems = this.extesionItems;
      this.extesionOptItems = this.extesionOptItems.filter((item) => item !== value);
    },

    SelectedRole(value) {
      if (value === 10) {
        this.getUserQueuesAndExtensions();
      }
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllQueues) {
          this.queueSelected = [];
        } else {
          this.queueSelected = this.queueItems.map((item) => item.number);
        }
      });
    },

    closedialog(newData) {
      this.$emit("dialog:change", newData);
    },
    async sendform() {
      try {
        this.loading = true;

        if (this.data.role_id === 10) await this.sendUserQueuesAndExtensions();
        if (this.type === "AgentList") {
          const accessToken = localStorage.getItem("token");

          axios
            .put(
              `${process.env.VUE_APP_ROOTAPI}/clients/manager/agents/${this.data.id}`,
              {
                queues: this.queueSelected,
                extension: this.extesionSelected === "Variable" ? null : this.extesionSelected,
                extension_opcional: this.extesionOptSelected === "Variable" ? 0 : this.extesionOptSelected,
                auto_connection: this.data.auto_connection === true ? 1 : 0,
                priority_order: Number(this.userPriority),
                enable_queues_chat: this.data.enable_queues_chat,
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              },
            )
            .then((res) => {
              this.$snotify.success("El usuario se ha actualizado con éxito.", "¡Hecho!");
              this.closedialog(res.data);
            })
            .catch(() => {
              // console.error(error);
              this.$snotify.error("No se pudo actualizar los datos del usuario.", "¡Error!");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          await this.$store.dispatch("user/UPDATE_USER", {
            id: this.data.id,
            name: this.data.name,
            email: this.data.email,
            password: this.data.password,
            role_id: this.data.role_id,
            auto_connection: this.data.auto_connection,
            enable_queues_chat: this.data.enable_queues_chat,
          });

          this.$snotify.success("El usuario se ha actualizado con éxito.", "¡Hecho!");
          this.loading = false;
          this.closedialog("cerrar");
        }
      } catch (error) {
        this.loading = false;
        this.$snotify.error("No se pudo actualizar los datos.", "¡Error!");
        // console.error(error);
      }
    },

    async sendUserQueuesAndExtensions() {
      const payload = {
        extensions: this.selectedUserExtensions.map((el) => String(el)),
        queuesIds: this.selectedUserQueues,
      };
      await PbxHttpClient.put(`/users/${this.data.id}/update-queues-extensions`, payload);
    },

    async getQueues() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listQueue`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.queueItems = res.data.data;

          // if (this.data.queues !== null) {
          //     this.queueItems.unshift(this.data.queues);
          // }
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
        })
        .finally(() => {
          this.isLoadingQueueItems = false;
        });
    },

    async getExtension() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listExtension`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.userExtensionOptions = [...new Set(res.data)];
          this.extesionItems = res.data;
          this.extesionOptItems = res.data;

          if (this.data.extension !== null) {
            this.extesionItems.unshift(this.data.extension);
          }
          if (this.data.extension_opcional !== null) {
            this.extesionOptItems.unshift(this.data.extension_opcional);
            this.extesionOptItems = this.extesionOptItems.filter((item) => item !== this.data.extension);
          }
          this.extesionItems.unshift("Variable");
          this.extesionOptItems.unshift("Variable");
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo obtener listado de extensiones.", "¡Error!");
        })
        .finally(() => {
          this.isLoadingExtensionItems = false;
        });
    },
    async getUserQueuesAndExtensions() {
      try {
        const res = await PbxHttpClient.get(`/users/${this.data.id}/queues-extensions`);
        this.selectedUserExtensions = res.data.extensions.map((ext) => +ext);
        this.selectedUserQueues = res.data.queues.map((queue) => queue.id);
      } catch (error) {
        console.log("error getting user and extensions");
        this.$snotify.error("No se pudo obtener listado de extensiones y colas del usuario.", "¡Error!");
      }
    },
  },
};
</script>
